import { Tracker } from './tracker';
import { Delivery } from './delivery';

export class Customer {

    public id:number;
    public name:string;
    public trackers:Array<Tracker>;
    public deliveries:Array<Delivery>;

    public lat : string;
    public lng : string;
    
    constructor (id:number, name:string, trackers:Array<Tracker>, lat:string, lng:string) {
        this.id = id;
        this.name = name;
        this.trackers = trackers;
        this.lat = lat;
        this.lng = lng;
    }    
}


// WEBPACK FOOTER //
// ./node_modules/angular-router-loader/src!./node_modules/angular2-template-loader?keepUrl=true!./app/shared/entities/customer.ts